import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api';

export type MatchStatus = 'matched' | 'ambiguous' | 'centavos' | 'unmatched' | 'duplicate_fit';

export interface TransacaoCandidato {
  pagamentoId: string;
  credorNome: string;
  valor: string;
  dataPagamento: string;
  diff: number;
}

export interface MatchSuggestion {
  transacao: {
    tipo: 'CREDIT' | 'DEBIT' | 'OUTRO';
    data: string;
    valor: string;
    descricao: string;
    nome: string | null;
    fitId: string | null;
  };
  status: MatchStatus;
  candidatos: TransacaoCandidato[];
}

export interface ParseResult {
  banco: string | null;
  conta: string | null;
  saldoFinal: string | null;
  totalTransacoes: number;
  sugestoes: MatchSuggestion[];
}

function basePath(workspaceId: string): string {
  return `/v1/workspaces/${workspaceId}/conciliacao`;
}

export function useParseOfx(workspaceId: string | null | undefined) {
  return useMutation({
    mutationFn: (content: string) =>
      api.post<ParseResult>(`${basePath(workspaceId!)}/parse`, { content }),
  });
}

export function useApplyConciliacao(workspaceId: string | null | undefined) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (pagamentoIds: string[]) =>
      api.post<{ updated: number }>(`${basePath(workspaceId!)}/apply`, { pagamentoIds }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['pagamentos', workspaceId] });
    },
  });
}
